/** @jsxImportSource @emotion/react */
import { Trans } from '@lingui/react/macro';
import React from 'react';
import type { DivProps } from 'typings';
import * as S from './styles';

interface IStubDescriptionProps extends DivProps {}

function StubDescription(props: IStubDescriptionProps) {
  const { ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      <Trans>Для завершения входа и работы с сервисом, пожалуйста, установите наше мобильное приложение.</Trans>
    </S.MainBlock>
  );
}

export default StubDescription;
